import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col } from 'antd';

import { CustomFormItem, CustomRow } from './styles';

interface RiskDescriptionProps {
	riskDescription: string;
}

export const RiskDescription: React.FC<RiskDescriptionProps> = ({ riskDescription }) => {
	return (
		<Col xs={24} sm={12} lg={24}>
			<CustomFormItem label={I18n.get('Risk description')} labelCol={{ span: 24 }}>
				<CustomRow>{I18n.get(riskDescription)}</CustomRow>
			</CustomFormItem>
		</Col>
	);
};
